import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Address} from "../../models/address.model";
import {AddressFacadeService} from "../../angular/state/addresses-facade.service";
import {AddressRequestType} from "../../angular/types/address-request.type";

export class AddressQualityCtrl implements IController {

  address: Address;
  query: any;
  type: AddressRequestType;

  public canResolver: boolean;
  public canUpdateResolver: boolean;

  /* @ngInject */
  constructor(private IAMPermissions, private addressFacadeService: AddressFacadeService) {
  }

  $onInit() {
    if (_.isUndefined(this.canResolver)) {
      this.canResolver = this.IAMPermissions.hasPermission('addressResolver.list');
      this.canUpdateResolver = this.IAMPermissions.hasPermission('addressResolver.update');
    }
  }

  onSelectAddress() {
    this.addressFacadeService.setAddressId(this.address.entryId, this.query, this.type);
  }

}

angular
  .module('bringoz.admin.addresses')
  .component('addressQuality', {
    bindings: {
      address: '<',
      query: '<',
      type: '<'
    },
    template: require('./address-quality.html').default,
    controller: AddressQualityCtrl
  });
